import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { BasicOrderMeal, BasicOrderMealItemWithContents, Menu, OrderMeal, OrderMealItem } from '@/models';
import { ui } from '@/constants';

@Component({
  name: 'CmgFullOrderDetailsModal',
})
export default class CmgFullOrderDetailsModal extends Vue {
  addingToBag = false;

  get args() {
    return this.$appStore.state.ui.modals.fullOrderDetails.args;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.fullOrderDetails.visible;
  }

  get closeIconUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  get meals(): BasicOrderMeal[] {
    return (this.args && this.args.order.meals) || [];
  }

  get menu(): Menu | null {
    return this.$appStore.state.menu.activeMenu;
  }

  get orderName(): string {
    return (this.args && this.args.name) || '';
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneSmMax;
  }

  formatEntree(entree: BasicOrderMealItemWithContents): string {
    if (!this.menu) {
      return '';
    }

    return this.$services.entree.getFormattedDetails(entree, this.menu);
  }

  close() {
    this.$services.ui.setModalVisibility('fullOrderDetails', false);
    this.$services.ui.focusBack();
  }

  modalClose() {
    this.$services.ui.setModalVisibility('fullOrderDetails', false);
    this.$services.ui.clearLastSelectedElement();
    Vue.nextTick(() => {
      setTimeout(() => {
        Vue.nextTick(()=>this.$services.ui.focusDiv('.fullModal'));
        this.$services.ui.setLastSelectedElement('bag');
      }, 1000);
    });
  }

  async onClickAddToBag() {
    if (!this.args) {
      return;
    }

    this.addingToBag = true;

    try {
      await this.args.onClickAddToBag();
      this.modalClose();
    } finally {
      this.addingToBag = false;
    }
  }

  getItemsInMeal(meal: OrderMeal): OrderMealItem[] {
    return (meal.sides || []).concat(meal.drinks || []);
  }
}
